import styled from 'styled-components'

export const Wrapper = styled.div``

export const Children = styled.ul`
  margin: 0;
  padding-inline-start: 0;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
`

export const ChildWrapper = styled.li`
  width: 100%;
  
  &:not(:first-child) {
    margin-top: 10px;
  }
`

export const Card = styled.ul`
  padding-inline-start: 0;
  list-style-type: none;
  padding: 15px;
  flex: 1;
  border: 1px solid #ccc;
  border-radius: 4px;
  opacity: ${p => p.isSummary || p.selected ? 1 : 0.66};
  box-shadow: ${p => !p.builder && p.selected ? '0 0 0 1px inset rgb(0, 102, 153)' : 'none'};
  cursor: ${p => !p.isSummary ? 'pointer' : 'default'};
  user-select: ${p => p.isSummary ? 'auto' : 'none'};
`

export const InfoWrapper = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 0.9rem;

  &:nth-child(even) {
    background-color: #d6e5f2;
  }

  &:not(:first-child) {
    padding: 4px 7px;
  }
`

export const Name = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  font-weight: bold;
  color: rgb(0, 102, 153);
`

export const Icon = styled.em`
  margin-right: 8px;
  font-size: 1.4rem;
`

export const InfoLeft = styled.div`
  font-weight: bold;
`

export const InfoRight = styled.div``

export const Error = styled.div``